import { arrayOf, bool, element, eventListener, expression, extendComponent, object, oneOf, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import { FieldVisibility } from '../field/field-constants.js';
const FieldsetProperties = {
    children: {
        type: oneOfType([element, arrayOf(element)]).notEnumerable(),
    },
    className: {
        type: string,
    },
    collapsible: {
        defaultValue: false,
        type: bool,
    },
    data: {
        defaultValue: {},
        type: object.notEnumerable(),
    },
    editing: {
        defaultValue: false,
        type: bool.notEnumerable(),
    },
    entry: {
        defaultValue: '',
        type: string,
    },
    onChange: {
        type: eventListener,
    },
    onCollapse: {
        type: eventListener,
    },
    section: {
        defaultValue: {
            showCollapseButton: undefined,
            title: '',
        },
        type: extendComponent('SubSection', ['title', 'showCollapseButton'], ['inlineActionsDesktopLimit', 'theme']),
    },
    title: {
        type: expression,
    },
    uuid: {
        defaultValue: '',
        type: string,
    },
    visibility: {
        defaultValue: FieldVisibility.BOTH,
        type: oneOf(enumValues(FieldVisibility)),
    },
    visible: {
        defaultValue: true,
        type: bool,
    },
};
export { FieldsetProperties, };
//# sourceMappingURL=fieldset-types.js.map